import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import { Row, Col, Button, Form } from 'react-bootstrap';
import { Unit } from '../../../helpers/unit';
import { setSelectedLoadIds, getLoadQueueList, setLoadQueueNotes } from '../../../actions/load';
import { editLoad } from '../../../actions/equipment-group';
import LoadCardLeft from './LoadCardLeft';
import { useLoadQueueContext } from './context/LoadQueueContext';
import { getDisplayDate, getDisplayTime } from '../utils';
import { isPlannedOrTodate, isToday } from '../../../helpers/common';
import { API_DATETIME_FORMAT, LOGISTIC_PLAN_TYPE_ID } from '../../../constants';
import { LoadNotePopup } from '../../LoadHistory/LoadNotePopup';
import { SeedNotePopup } from '../../seedHistory/SeedNotePopup';
import { LogisticsNotePopup } from '../../Logistics/LogisticsNotePopup';
import { Icon } from '../../widgets';
import LoadSample from '../../../constants/LoadSample';
import LoadSampleProfileTable from '../../../constants/LoadSampleProfileTable';
import { getUserId } from '../../../helpers/session';
import { saveScaleInfo } from '../../../actions/remote-scale';
import LoadPreview from '../../LoadHistory/LoadPreview';
import { parseLoadQueuePrint } from '../../../interceptors/load';
import MultiSelect from '../../../constants/MultiSelect';

const LoadCardOne = props => {
  const planTypeId = useSelector(state => state.plan.selectedPlanType);
  const farmSettings = useSelector(state => state.farm.farmSettings.farm_config);
  const scaleSocket = useSelector(state => state.scaleSocket);
  const customerList = useSelector(state => state.load.loadQueueCustomerList.data.customer);
  const farmId = useSelector(state => state.farm.currentFarm.farm_uuid);
  const timezone = useSelector(state => state.farm.currentFarm.timezone_identifier);
  const geoStorageLocations = useSelector(state => state.geo.geoStorageLocations.payload);
  const { unLoadSiteList, selectedLoadIds, loadQueueType } = useSelector(state => state.load);
  const weightShortName = useSelector(state => state.user.settings.weightShortName);
  const search = useSelector(state => state.analyze.searchParams);
  const roleId = useSelector(state => state.auth.userInfo.role_id);
  const dispatch = useDispatch();

  const unit = Unit.getInstance();
  const { range, custom } = search;
  const { load, onChange, formDatas, isApproveDataValid } = props;

  const [isChecked, setIsChecked] = useState(false);
  const [isEdited, setEdited] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isEditedLoad, setEditedLoad] = useState(false);
  const [loadQueueData, setLoadQueueData] = useState({
    loadCapacity: unit.toWeight(load.loadCapacity, 2),
    loadGrossWeight: load.loadGrossWeight ? unit.toWeight(load.loadGrossWeight, 2) : unit.toWeight(load.estimatedLoadCapacity, 2),
    tareWeight: load.tareWeight ? unit.toWeight(load.tareWeight, 2) : "",
    lightWeight: load.lightWeight ? unit.toWeight(load.lightWeight, 2) : "",
    estimatedLoadCapacity: unit.toWeight(load.estimatedLoadCapacity, 2),
    offloadGeoShapeId: load.offloadGeoShapeId || null,
    offloadStorageLocationId: load.offloadStorageLocationId || "",
    pipe: load.pipe ? load.pipe : null,
    load_params: load.load_params ? load.load_params : null,
    targetPlanTypeId: load.targetPlanTypeId ? load.targetPlanTypeId : null,
    customerUuid: load.customerId ? load.customerId : null
  });
  const [showModal, setShowModal] = useState({
    loadSample: false,
    loadSampleProfileTable: false,
    loadTicketPreview: false
  });
  const { multiApporveData, setMultiApporveData, editedLoadsById, setIsEdited } = useLoadQueueContext();
  let { load_params = {} } = loadQueueData;
  const [showError, setShowError] = useState(false);

  const getPrintLoad = () => {
    let loadData = parseLoadQueuePrint(load);
    loadData = {
      ...loadData,
      "load_capacity": unit.toWeight(loadData.load_capacity, 2),
      "light_weight": unit.toWeight(loadData.light_weight, 2),
      "load_gross_weight": unit.toWeight(loadData.load_gross_weight, 2),
      "tare_weight": unit.toWeight(loadData.tare_weight, 2),
      "estimated_load_capacity": unit.toWeight(loadData.estimated_load_capacity, 2)
    }
    return loadData;
  }

  useEffect(() => {
    if (editedLoadsById[load.loadActivityId] && editedLoadsById[load.loadActivityId].loadCapacity)

      onChange(load.loadActivityId, {
        loadCapacity: unit.toWeight(load.loadCapacity, 2),
        tareWeight: unit.toWeight(load.tareWeight, 2),
        loadGrossWeight: load.loadGrossWeight ? unit.toWeight(load.loadGrossWeight, 2) : "",
        lightWeight: load.lightWeight ? unit.toWeight(load.lightWeight, 2) : ""
      });

    setLoadQueueData({
      ...loadQueueData,
      loadCapacity: unit.toWeight(load.loadCapacity, 2),
      tareWeight: unit.toWeight(load.tareWeight, 2),
      loadGrossWeight: load.loadGrossWeight ? unit.toWeight(load.loadGrossWeight, 2) : unit.toWeight(load.estimatedLoadCapacity, 2),
      estimatedLoadCapacity: unit.toWeight(load.estimatedLoadCapacity, 2),
      lightWeight: unit.toWeight(load.lightWeight, 2),
      targetPlanTypeId: load.targetPlanTypeId ? load.targetPlanTypeId : null
    });
  }, [weightShortName]);

  useEffect(() => {
    if (selectedLoadIds.indexOf(load.loadActivityId) >= 0) !isChecked && setIsChecked(true);
    else if (isChecked) setIsChecked(false);
  }, [selectedLoadIds]);

  useEffect(() => {
    if (!isChecked) {
      setLoadQueueData({
        loadCapacity: unit.toWeight(load.loadCapacity, 2),
        tareWeight: unit.toWeight(load.tareWeight, 2),
        estimatedLoadCapacity: unit.toWeight(load.estimatedLoadCapacity, 2),
        loadGrossWeight: load.loadGrossWeight ? unit.toWeight(load.loadGrossWeight, 2) : unit.toWeight(load.estimatedLoadCapacity, 2),
        lightWeight: load.lightWeight ? unit.toWeight(load.lightWeight, 2) : "",
        offloadGeoShapeId: load.offloadGeoShapeId || null,
        offloadStorageLocationId: load.offloadStorageLocationId || "",
        load_params: load.load_params ? load.load_params : null,
        customerUuid: load.customerId ? load.customerId : null,
        targetPlanTypeId: load.targetPlanTypeId ? load.targetPlanTypeId : null
      });
    }
  }, [isChecked]);

  useEffect(() => {
    if (selectedLoadIds.indexOf(load.loadActivityId) >= 0) {
      setLoadQueueData({ ...loadQueueData, ...multiApporveData });
      onChange(load.loadActivityId, multiApporveData);
    }
  }, [multiApporveData, selectedLoadIds]);

  const isAllowSample = useMemo(() => {
    if (farmSettings && farmSettings.seed_load_sample && farmSettings.seed_load_sample.visible && farmSettings.seed_load_sample.plan_type_ids) {
      const configPlanTypeIds = farmSettings.seed_load_sample.plan_type_ids;
      return configPlanTypeIds.length > 0 ? farmSettings.seed_load_sample.plan_type_ids.includes(planTypeId) : false;
    }
    return false;

  }, [farmSettings, planTypeId]);

  const isSeedPieceProfile = useMemo(() => {
    if (farmSettings && farmSettings.seed_piece_profile_sample && farmSettings.seed_piece_profile_sample.visible) {
      return farmSettings.seed_piece_profile_sample.visible;
    }
    return false

  }, [farmSettings]);

  const { isPrintLoadTicket } = useMemo(() => {
    let printTicket = false;
    if (farmSettings && Object.keys(farmSettings).length > 0) {
      const print_load_ticket = (farmSettings.print_load_ticket) ? farmSettings.print_load_ticket : null;
      if (print_load_ticket && print_load_ticket.visible && print_load_ticket.visible) {
        printTicket = true;
      }
    }
    return { isPrintLoadTicket: printTicket }
  }, [farmSettings]);

  const getStorageLocationList = (loadQueueData) => {
    try {
      const { offloadGeoShapeId } = loadQueueData;
      const findShape = unLoadSiteList.find(e => e.geo_shape_uuid === offloadGeoShapeId) || {};
      const geo_region_shape_uuid = findShape.geo_shape_object_uuid;

      let storageLocations = (Array.isArray(geoStorageLocations[geo_region_shape_uuid]) ? geoStorageLocations[geo_region_shape_uuid] : null)
        || (Array.isArray(findShape.geo_storage_locations) ? findShape.geo_storage_locations : null)
        || [];
      storageLocations = JSON.parse(JSON.stringify(storageLocations));

      if (offloadGeoShapeId && storageLocations.length === 0) {
        storageLocations.push({
          geo_region_shape_uuid: geo_region_shape_uuid,
          geo_storage_location_uuid: "default",
          storage_location_name: "Default",
        });
      }
      return storageLocations;
    } catch (ex) {
      console.log(ex);
      return [];
    }
  };

  const { socketConneted, runningWeight, scaleAtStandStill, grossOrNet } = useMemo(() => {
    const { isConnected, scaleWeightInfo } = scaleSocket;
    const { weight: scaleWeight, scale_at_standstill, gross_or_net } = scaleWeightInfo;
    return { socketConneted: isConnected, runningWeight: scaleWeight, scaleAtStandStill: scale_at_standstill, grossOrNet: gross_or_net }
  }, [scaleSocket]);

  const handleSelection = (id, isChecked) => {
    if (socketConneted) {
      if (selectedLoadIds.indexOf(id) >= 0) {
        selectedLoadIds.splice(selectedLoadIds.indexOf(id), 1);
        if (isEdited) setEdited(false);
      } else if (selectedLoadIds.length === 0 && scaleAtStandStill) {
        selectedLoadIds.push(id);
      } else {
        return;
      }
    }
    else if (selectedLoadIds.indexOf(id) >= 0) selectedLoadIds.splice(selectedLoadIds.indexOf(id), 1);
    else selectedLoadIds.push(id);
    setIsChecked(isChecked);

    const { targetEquipmentGroupId } = load;
    if (selectedLoadIds.indexOf(id) === 0 && socketConneted && targetEquipmentGroupId) {
      const newGrossWeight = (grossOrNet && grossOrNet === 'G') ? runningWeight : loadQueueData.loadGrossWeight;
      const netWeight = (grossOrNet && grossOrNet === 'N') ? runningWeight : Number(newGrossWeight) -
        (Number(loadQueueData.tareWeight) + Number(loadQueueData.lightWeight));

      let newLoadQueueData = { ...loadQueueData, loadCapacity: netWeight, loadGrossWeight: newGrossWeight };

      setLoadQueueData(newLoadQueueData);
      if (!isEdited && ((loadQueueData.loadCapacity !== netWeight) || (loadQueueData.loadGrossWeight !== newGrossWeight))) {
        setEdited(true);
        onChange(load.loadActivityId, { loadGrossWeight: newGrossWeight, loadCapacity: netWeight });
      }
    }
    dispatch(setSelectedLoadIds([...selectedLoadIds]));
  };

  let loadGrossWeight = 0;

  const handleChange = (name, value) => {
    const inputValue = value.toString().trim();

    if (name === 'tareWeight') {
      let tareWeight = Number(value);
      let netValue = loadQueueData.loadGrossWeight - (tareWeight + loadQueueData.lightWeight);

      let newLoadQueueData = { ...loadQueueData, loadCapacity: netValue, tareWeight };
      let newMultiApproveData = { ...multiApporveData, loadCapacity: netValue, tareWeight };

      if (inputValue.length === 0) {
        setEdited(false);
      }
      else {
        setEdited(true);
      }

      setLoadQueueData(newLoadQueueData);
      onChange(load.loadActivityId, { tareWeight: tareWeight, loadCapacity: netValue });
      if (selectedLoadIds.indexOf(load.loadActivityId) >= 0) setMultiApporveData(newMultiApproveData);
    } else if (name === 'lightWeight') {
      let lightWeight = Number(value);
      let netValue = loadQueueData.loadGrossWeight - (loadQueueData.tareWeight + lightWeight);

      let newLoadQueueData = { ...loadQueueData, loadCapacity: netValue, lightWeight };
      let newMultiApproveData = { ...multiApporveData, loadCapacity: netValue, lightWeight };

      if (inputValue.length === 0) {
        setEdited(false);
      }
      else {
        setEdited(true);
      }

      setLoadQueueData(newLoadQueueData);
      onChange(load.loadActivityId, { lightWeight, loadCapacity: netValue });
      if (selectedLoadIds.indexOf(load.loadActivityId) >= 0) setMultiApporveData(newMultiApproveData);
    }
    else if (name === "loadGrossWeight") {
      let netWeight = 0;

      if (inputValue.length === 0) {
        setEdited(false);
      }
      else {
        if (Number(unit.toWeight(load.loadGrossWeight, 2)) === Number(value)) setEdited(false);
        else setEdited(true);
      }

      loadGrossWeight = Number(value);
      netWeight = Number(loadGrossWeight) - (Number(loadQueueData.tareWeight) + Number(loadQueueData.lightWeight));

      let newLoadQueueData = { ...loadQueueData, loadCapacity: netWeight, loadGrossWeight: loadGrossWeight };

      setLoadQueueData(newLoadQueueData);
      onChange(load.loadActivityId, { loadGrossWeight: loadGrossWeight, loadCapacity: netWeight });
      let newMultiApproveData = { ...multiApporveData, loadGrossWeight: loadGrossWeight, loadCapacity: netWeight };

      if (selectedLoadIds.indexOf(load.loadActivityId) >= 0) setMultiApporveData(newMultiApproveData);
    }
    else if (name === "loadCapacity") {
      let netWeight = 0;

      if (inputValue.length === 0) {
        setEdited(false);
      }
      else {
        if (Number(unit.toWeight(load.loadGrossWeight, 2)) === Number(value)) setEdited(false);
        else setEdited(true);
      }
      netWeight = Number(value);
      loadGrossWeight = Number(netWeight) + Number(loadQueueData.tareWeight) + Number(loadQueueData.lightWeight);

      let newLoadQueueData = { ...loadQueueData, loadCapacity: netWeight, loadGrossWeight: loadGrossWeight };

      setLoadQueueData(newLoadQueueData);
      onChange(load.loadActivityId, { loadGrossWeight: loadGrossWeight, loadCapacity: netWeight });
      let newMultiApproveData = { ...multiApporveData, loadGrossWeight: loadGrossWeight, loadCapacity: netWeight };

      if (selectedLoadIds.indexOf(load.loadActivityId) >= 0) setMultiApporveData(newMultiApproveData);
    }
    else {
      let loadCapacity = Number(unit.toWeight(load.estimatedLoadCapacity, 2));
      let newLoadQueueData = { ...loadQueueData, loadCapacity: loadCapacity, [name]: value };
      let newMultiApproveData = { ...multiApporveData, loadCapacity: loadCapacity, [name]: value };
      let newOnChangeData = { [name]: value };

      if (name === 'offloadGeoShapeId') {
        const storageLocationList = getStorageLocationList(newLoadQueueData);
        const offloadStorageLocationId = storageLocationList.length > 0 ? storageLocationList[0].geo_storage_location_uuid : null;
        newLoadQueueData = { ...newLoadQueueData, offloadStorageLocationId };
        newMultiApproveData = { ...newMultiApproveData, offloadStorageLocationId };
        newOnChangeData = { ...newOnChangeData, offloadStorageLocationId };
      }

      setLoadQueueData(newLoadQueueData);
      onChange(load.loadActivityId, newOnChangeData);
      if (selectedLoadIds.indexOf(load.loadActivityId) >= 0) setMultiApporveData(newMultiApproveData);
    }
  };

  const handleSelect = (options, id) => {
    const loadParams = loadQueueData.load_params ? loadQueueData.load_params : {};
    loadParams[id] = (options && options.value) ? options.value : null;
    const newLoadQueueData = { ...loadQueueData, load_params: { ...loadParams } };
    setLoadQueueData(newLoadQueueData);
    setDynamicInputsChanges(newLoadQueueData, loadParams);
  }
  const handleSelectDropdown = (options, id) => {
    const selectedValue = (options && options.value) ? options.value : null;
    const newLoadQueueData = { ...loadQueueData, [id]: selectedValue };
    setEdited(true)
    setLoadQueueData(newLoadQueueData);
  }
  const [selectedOptions, setSelectedOptions] = useState([]);
  const handleMultiSelectChange = (options, id) => {
    setEdited(true)
    const loadParams = loadQueueData.load_params ? loadQueueData.load_params : {};
    loadParams[id] = options ? options.map(option => option.value) : [];
    const newLoadQueueData = { ...loadQueueData, load_params: { ...loadParams } };
    setLoadQueueData(newLoadQueueData);
    setDynamicInputsChanges(newLoadQueueData, loadParams);
    setSelectedOptions(options);
  };

  const handleTextChange = (type, keyValue, value) => {
    let inputValue = value ? value.toString().trim() : '';
    inputValue = (inputValue && type === 'number') ? Number(inputValue) : inputValue;

    const loadParams = loadQueueData.load_params ? loadQueueData.load_params : {};
    loadParams[keyValue] = inputValue
    const newLoadQueueData = { ...loadQueueData, load_params: { ...loadParams } };
    setDynamicInputsChanges(newLoadQueueData, loadParams);
  }

  const setDynamicInputsChanges = (newLoadQueueData, loadParams) => {
    setLoadQueueData(newLoadQueueData);
    onChange(load.loadActivityId, {
      loadCapacity: loadQueueData.loadCapacity ? loadQueueData.loadCapacity : 0,
      tareWeight: loadQueueData.tareWeight ? loadQueueData.tareWeight : '',
      loadGrossWeight: loadQueueData.loadGrossWeight ? loadQueueData.loadGrossWeight : '',
      load_params: { ...loadParams }
    });
    setEdited(true);
  }

  const saveLoadSample = (saveLoad) => {
    // dispatch(editLoad({ ...saveLoad, planTypeId }))
    dispatch(editLoad({ ...saveLoad, planTypeId }, ((isSaved, params) => {
      if (isSaved) {
        dispatch(setLoadQueueNotes(load, { seed_sample: params.seed_sample }));
      }
    })))
  }

  const handleSave = () => {
    const { loadCapacity, loadGrossWeight, tareWeight, load_params, customerUuid, lightWeight } = loadQueueData;
    const isValid = checkValidation();
    if (!isValid) return;
    setIsSaving(true);
    const params = {
      farm_uuid: farmId,
      load_activity_uuid: load.loadActivityId,
      load_capacity: loadCapacity ? unit.fromWeight(loadCapacity, 2) : 0,
      load_gross_weight: loadGrossWeight ? unit.fromWeight(loadGrossWeight, 2) : 0,
      tare_weight: tareWeight ? unit.fromWeight(tareWeight) : 0,
      light_weight: lightWeight ? unit.fromWeight(lightWeight) : 0,
      last_modified_at: moment.utc().tz(timezone).format(),
      is_load_queue_edit: true,
      load_params: load_params ? load_params : null,
      planTypeId,
      customer_uuid: customerUuid ? customerUuid : null
    };

    dispatch(editLoad(params, (isSaved => {
      if (isSaved) setTimeout(() => { getLoadList() }, [500]);
      if (socketConneted && isSaved) {
        acknowledgeScale(params);
        dispatch(setSelectedLoadIds([]));
      };
      setEditedLoad(isSaved);
      setIsSaving(false);
      setEdited(false);
      setIsEdited(false);
    }))
    );
  };

  const acknowledgeScale = (data) => {
    if (socketConneted && data) {
      const { targetEquipmentGroupId } = load;
      const params = {
        ...scaleSocket.scaleWeightInfo,
        "equipment_group_uuid": targetEquipmentGroupId,
        "modified_by_uuid": getUserId()
      }
      let isWeightDiff = false;
      const gross = unit.toWeight(data.load_gross_weight, 2);
      const net = unit.toWeight(data.load_capacity, 2);
      if (grossOrNet && grossOrNet === 'G' && runningWeight !== gross) {
        params["weight"] = gross;
        isWeightDiff = true;
      } else if (grossOrNet && grossOrNet === 'N' && runningWeight !== net) {
        params["weight"] = net;
        isWeightDiff = true;
      }
      if (isWeightDiff) {
        params["original_data"] = scaleSocket.scaleWeightInfo
      }
      dispatch(saveScaleInfo(params));
    }
  }

  const checkValidation = () => {
    const { load_params } = loadQueueData;
    let isValid = true;
    if (formDatas && formDatas.length > 0) {
      for (let i = 0; i < formDatas.length; i++) {
        const formData = formDatas[i];
        if (!formData) continue;
        if (formData.required) {
          if (!load_params || (load_params && !load_params[formData.key])) {
            isValid = false;
            setShowError(true);
            break;
          }
        }

        if (load_params && load_params[formData.key] && formData.hasOwnProperty('rules') &&
          formData.rules.hasOwnProperty('max_length')
          && load_params[formData.key].toString().trim().length > formData.rules.max_length) {
          isValid = false;
          setShowError(true);
          break;
        }
      }
    }
    return isValid;
  }
  const recentHours = useMemo(() => {
    let updatedHours;
    if (farmSettings) {
      updatedHours = farmSettings && farmSettings.load_queue_recent_hours &&
        farmSettings.load_queue_recent_hours.recent_hours ?
        farmSettings.load_queue_recent_hours.recent_hours : 0;
      return updatedHours;
    }
  }, [farmSettings]);
  const getLoadList = () => {
    let from = null, to = null;

    if (!isPlannedOrTodate(range)) {
      if (custom.from && custom.to) {
        from = isToday(range) ? moment.utc(custom.from).subtract(recentHours, "hours").format(API_DATETIME_FORMAT) :
          moment.utc(custom.from).format(API_DATETIME_FORMAT);
        to = moment.utc(custom.to).format(API_DATETIME_FORMAT);
      } else {
        const now = moment.utc().tz(timezone);
        from = now.clone().startOf("day").format(API_DATETIME_FORMAT);
        to = now.clone().endOf("day").format(API_DATETIME_FORMAT);
      }
    }

    const loadParams = {
      farmId,
      rangeType: range,
      approved: (loadQueueType === 2),
      ...!isPlannedOrTodate(range) && { fromDate: from, toDate: to },
      is_current_customer_load: [9].includes(roleId),
      planTypeId
    };
    dispatch(getLoadQueueList(loadParams));
  };

  //     if ((multiApporveData || {}).offloadGeoShapeId && isChecked) {

  //         const shape = unLoadSiteList.find(item => item.geo_shape_uuid === multiApporveData.offloadGeoShapeId) || {};
  //         if (shape.geo_shape_name) data.selectedOffload = shape.geo_shape_name;

  //         if ((multiApporveData || {}).offloadStorageLocationId) {
  //             const storageLocations = shape.geo_storage_locations || [];
  //             const storage = storageLocations.find(item => item.geo_storage_location_uuid === multiApporveData.offloadStorageLocationId) || {};

  //             if (storage.storage_location_name) data.selectedStorage = storage.storage_location_name;
  //             else if (multiApporveData.offloadStorageLocationId === 'default') data.selectedStorage = multiApporveData.offloadStorageLocationId;

  //         }
  //     } else {
  //         if (load.offloadGeoShapeName) data.selectedOffload = load.offloadGeoShapeName;
  //         if (load.offloadStorageLocationName) data.selectedStorage = load.offloadStorageLocationName;
  //     }

  //     return data;

  // }, [unLoadSiteList, geoStorageLocations, load, isChecked]);

  const isSelected = useMemo(() => selectedLoadIds.indexOf(load.loadActivityId) >= 0,
    [selectedLoadIds, load.loadActivityId]);

  const handleShowModal = (type, show) => setShowModal({ ...showModal, [type]: show });

  const customerOptions = customerList && customerList.length > 0 ? customerList.map(it => ({ label: it.name, value: it.id })) : [];

  const isLogisticPlanSubHarvest = planTypeId === 5 && loadQueueData.targetPlanTypeId === 4;
  const customerValue = loadQueueData["customerUuid"] ? loadQueueData["customerUuid"] : null;

  return <div className="d-flex">
    <div className={`load-card queue-type ${isSelected && "selected"}`} id={load.loadActivityId}>
      <LoadCardLeft
        load={load}
        unit={unit}
        settings={props.settings}
      />
      <div className="load-card-main">
        <Row className="load-card-header m-0 justify-content-between px-2" onClick={() => (((socketConneted && isEdited) || !isEdited) && handleSelection(load.loadActivityId))} >
          <Col xs={12} className="dateTime-col">
            {planTypeId === LOGISTIC_PLAN_TYPE_ID && <>
              <div className='d-flex'>

                {load.sourceOffloadGeoShapeName && <div>
                  <div>{load.sourceOffloadGeoShapeName}</div>
                  <div className='d-flex align-items-center storage-pipe'>
                    <div>{load.sourceOffloadStorageLocationName}</div>
                    {load.sourcePipe ? <div className='splitter-two'></div> : null}
                    <div>{load.sourcePipe}</div>
                  </div>
                </div>}
                {load.offloadGeoShapeName &&
                  <><div className='d-flex justify-content-center align-items-center dot_arrow-hldr'>
                    <div className="dot_arrow_txt"></div>
                    <div className="dot_arrow_txt"></div>
                    <Icon title=""
                      ariaHidden="true"
                      className="fa fa-arrow-right mr-1"></Icon>
                  </div>
                    {load.offloadGeoShapeName && <div>
                      <div>{load.offloadGeoShapeName}</div>
                      <div className='d-flex align-items-center storage-pipe'>
                        <div>{load.offloadStorageLocationName}</div>
                        {load.pipe ? <div className='splitter-two'></div> : null}
                        <div>{load.pipe}</div>
                      </div>
                    </div>}
                  </>
                }
              </div>
            </>}
          </Col>
          <Col /* onClick={(e) => e.stopPropagation()} */ xs={12} className='d-flex cursor-default justify-content-between mt-1'
            style={{
              cursor: (isEdited || selectedLoadIds.length > 0) ? "not-allowed" : "pointer"
            }}>
            <div className='load-date align-self-end'>
              <div className="date">{getDisplayDate(load.loadDateTz)}</div>
              <div className="time">
                {getDisplayTime(load.startDateTz)}
              </div>
              {load.startDateTz && <span>-</span>}
              <div className="time">
                {getDisplayTime(load.endDateTz)}
              </div>
            </div>
            <div className='d-flex action-right-hldr'>
              {isSeedPieceProfile && <div>
                <Icon
                  title="Load Sample Profile Table"
                  onClick={() => handleShowModal("loadSampleProfileTable", true)}
                  className="fa fa-wpforms mx-1 cursor-pointer"
                  ariaHidden="true" />
              </div>}
              {isAllowSample &&
                <div>
                  <Icon
                    title="Load Sample"
                    onClick={() => handleShowModal("loadSample", true)}
                    className="fa fa-flask mx-1 cursor-pointer"
                    ariaHidden="true" />
                </div>
              }

              <GetLoadNotes planTypeId={planTypeId}
                isQueue={true}
                load={{ ...load, load_activity_uuid: load.loadActivityId }}
              />

              {isPrintLoadTicket ?
                <span className='mx-1'>
                  <Icon className="fa fa-print cursor-pointer" onClick={() => handleShowModal("loadTicketPreview", true)} />
                </span> : null
              }
              <Button className='btn-sm'
                style={{ cursor: (socketConneted && isEdited) ? "pointer" : (!isEdited || selectedLoadIds.length > 0) ? "not-allowed" : "pointer" }}
                disabled={(socketConneted && isEdited) ? false : (!isEdited || selectedLoadIds.length > 0)}
                onClick={() => handleSave()}>
                {isSaving ? 'Saving' : 'Save'}
              </Button>
            </div>
          </Col>
        </Row>
        <Row className="load-card-detail-1 m-0 mx-2">
          {!isLogisticPlanSubHarvest ? <>
            <Col xs={6}>
              <div className="label">Implement</div>
              <div className="text">{load.sourceEquipmentGroupName ? load.sourceEquipmentGroupName : "Unknown"}</div>
            </Col>
            {/* {planTypeId === LOGISTIC_PLAN_TYPE_ID ? <Col xs={6}>
              <div className="label">Seed Class</div>
              <div className="text">{load.seedClass ? load.seedClass : "Unknown"}</div>
            </Col> : null} */}

            {planTypeId !== LOGISTIC_PLAN_TYPE_ID ?
              <Col xs={6}>
                <div className="label">Field</div>
                <div className="text">{load.fieldGeoShapeName ? <>{load.fieldGeoShapeName}
                  {load.customerId && <small> | {load.customerName}</small>}
                  <small> | Tare factor: {load.tareFactor ? load.tareFactor : 0}%
                  </small>
                </> : "N/A"}</div>
              </Col> : null}
          </> : null}

          {
            isLogisticPlanSubHarvest ?
              <Col xs={6}>
                <Form.Label htmlFor="customer">Customer</Form.Label>
                <Form.Select
                  options={customerOptions}
                  id="customerUuid"
                  placeholder={`Select customer`}
                  name="customerUuid"
                  onChange={(e) => handleSelectDropdown(e, "customerUuid")}
                  value={customerValue}
                ></Form.Select>
              </Col> : null
          }
          {planTypeId === LOGISTIC_PLAN_TYPE_ID ? <Col xs={6}>
            <div className="label">{`Net Weight (${weightShortName})`}</div>
            <input
              type="number"
              className="input-type"
              value={loadQueueData.loadCapacity}
              onChange={e => handleChange("loadCapacity", e.target.value)} />
          </Col> : null}
          <Col xs={6}>
            <div className="label">{`${planTypeId === LOGISTIC_PLAN_TYPE_ID ? "Gross Weight":"Load Confirmation" } (${weightShortName})`}
              <span className='text-danger required'>*</span>
            </div>
            <input
              type="number"
              className="input-type"
              value={loadQueueData.loadGrossWeight}
              style={{ width: "90%" }}
              onChange={e => handleChange("loadGrossWeight", e.target.value)} />

            {(isEditedLoad || load.lastModifiedAt) && <span className="isEdited ml-1">
              <i className='fa fa-check' title={load && load.lastModifiedAt ? moment.utc(load.lastModifiedAt).format("DD MMM YYYY hh:mm A") : ""} style={{ color: "green" }} />
            </span>}
          </Col>
          <Col xs={6}>
            <div className="label">{`Tare Weight (${weightShortName})`}</div>
            <input
              type="number"
              className="input-type"
              value={loadQueueData.tareWeight}
              max={unit.toWeight(load.estimatedLoadCapacity, 2)}
              min={0}
              onChange={e => handleChange("tareWeight", e.target.value)} />
          </Col>
          {planTypeId === LOGISTIC_PLAN_TYPE_ID ? <Col xs={6}>
            <div className="label">{`Light Weight (${weightShortName})`}</div>
            <input
              type="number"
              className="input-type"
              value={loadQueueData.lightWeight}
              onChange={e => handleChange("lightWeight", e.target.value)} />
          </Col> : null}

          {formDatas && formDatas.length ?
            formDatas.map(e => {
              const keyValue = e.key;
              const value = load_params ?
                load_params.hasOwnProperty(keyValue) ? load_params[keyValue] : null : null;

              const multipleValues = e.isMulti && e.default_values && Array.isArray(e.default_values)
                ? e.default_values.map(value => ({
                  label: value,
                  value: value,
                }))
                : []

              const FinalValue = (e.isMulti && multipleValues && multipleValues.length > 0) && e.options.filter((e) =>
                multipleValues.some((item) => item.value === e.value)
              )
              const defaultValues = load_params && load_params.hasOwnProperty(keyValue)
                ? (keyValue === 'load_debris' && Array.isArray(load_params[keyValue]) && load_params[keyValue].length > 0)
                  ? load_params[keyValue].map(value => ({
                    label: value,
                    value: value,
                  }))
                  : FinalValue
                : FinalValue
              return (
                (e.type && e.type === 'multiselect' && e.visible && e.isMulti) ?
                  <Col className='col-6' key={keyValue}>
                    <Form.Label htmlFor={keyValue}>{e.label ? e.label : ''}
                      {(e.required) ? <small className="error-mand ml-1">*</small> : null}</Form.Label>
                    <MultiSelect
                      closeMenuOnSelect={false}
                      defaultValue={defaultValues}
                      isMulti={true}
                      isClearable={true}
                      placeholder={e.label}
                      value={selectedOptions}
                      options={e.options}
                      designType="checkbox"
                      onChange={(e) => handleMultiSelectChange(e, keyValue)}
                    />
                    {(((!isApproveDataValid && selectedLoadIds.indexOf(load.loadActivityId) >= 0) || showError) && e.required && !value) ?
                      <small className="form-text text-error">{e.label} is required.</small> : null}
                  </Col> :
                  (e.type && e.type === 'options' && e.visible && e.showInLoadQueue) ?
                    <Col className='col-6' key={keyValue}>
                      <Form.Label htmlFor={keyValue}>{e.label ? e.label : ''}
                        {(e.required) ? <small className="error-mand ml-1">*</small> : null}</Form.Label>
                      <Form.Select
                        options={e.options}
                        id={keyValue}
                        placeholder={`Select ${e.label}`}
                        name={keyValue}
                        onChange={(e) => handleSelect(e, keyValue)}
                        value={value ? value : e.default_value ? e.default_value : ''}
                      />
                      {(((!isApproveDataValid && selectedLoadIds.indexOf(load.loadActivityId) >= 0) || showError) && e.required && !value) ?
                        <small className="form-text text-error">{e.label} is required.</small> : null}
                    </Col>
                    : ((e.type && e.visible && e.showInLoadQueue) && (e.type === 'text' || e.type === 'number')) ?
                      <Col className='col-6' key={keyValue}>
                        <Form.Label htmlFor={keyValue}>{e.label ? e.label : ''}
                          {(e.required) ? <small className="error-mand ml-1">*</small> : null}</Form.Label>
                        <input
                          type={e.type}
                          className="input-type"
                          value={value ? value : ''}
                          onChange={i => handleTextChange(e.type, keyValue, i.target.value)} />

                        {(((!isApproveDataValid && selectedLoadIds.indexOf(load.loadActivityId) >= 0) || showError) && e.required && !value)
                          ? <small className="form-text text-error">{e.label} is required.</small> : null}

                        {(value && e.rules && e.rules.hasOwnProperty('max_length')
                          && (value.length > e.rules.max_length)) ?
                          <small className="form-text text-error">Length can not exceed {e.rules.max_length}.</small> : null}
                      </Col>
                      : null
              )
            }
            ) : null}
        </Row>
        {/* <Row className="load-card-detail-2 m-0">
                    <Col>
                        <div className="label">Offload Site</div>
                        <div className="text">{selectedOffload}</div>
                         <Form.Select
                            value={loadQueueData.offloadGeoShapeId}
                            options={unLoadSiteList.map(e => ({ value: e.geo_shape_uuid, label: e.geo_shape_name }))}
                            onChange={e => handleChange("offloadGeoShapeId", e ? e.value : null)}
                        /> 
                    </Col>
                    <Col>
                        <div className="label">Storage</div>
                        <div className="text">{selectedStorage}</div>
                         <Form.Select
                            value={loadQueueData.offloadStorageLocationId}
                            options={offloadStorageLocationList.map(e => ({ value: e.geo_storage_location_uuid, label: e.storage_location_name }))}
                            onChange={e => handleChange("offloadStorageLocationId", e ? e.value : null)}
                        /> 
                    </Col>
                </Row> */}
      </div>
    </div>
    <div className="select-input">
      <div className="checkmark-container">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={(e) => handleSelection(load.loadActivityId, e.target.value)}
        />
        <span className={`checkmark`}></span>
      </div>
    </div>
    {
      showModal.loadSample && <LoadSample
        show={showModal.loadSample}
        onHide={() => setShowModal({ ...showModal, loadSample: false })}
        load={{ ...load, load_activity_uuid: load.loadActivityId, farm_uuid: load.farmId }}
        farmId={farmId}
        saveSample={saveLoadSample}
      />
    }

    {
      showModal.loadSampleProfileTable && <LoadSampleProfileTable
        show={showModal.loadSampleProfileTable}
        onHide={() => setShowModal({ ...showModal, loadSampleProfileTable: false })}
        load={{ ...load, load_activity_uuid: load.loadActivityId, farm_uuid: load.farmId }}
        farmId={farmId}
        saveSample={saveLoadSample}
      />
    }
    {
      (showModal.loadTicketPreview) ? <LoadPreview show={showModal.loadTicketPreview} load={getPrintLoad()}
        onHide={() => setShowModal({ ...showModal, loadTicketPreview: false })} /> : null
    }
  </div>;
};

const GetLoadNotes = (props) => {
  const { planTypeId } = props;
  if (planTypeId && planTypeId === 2) {
    return (<SeedNotePopup {...props} />);
  } else if (planTypeId && planTypeId === 5) {
    return (<LogisticsNotePopup {...props} />);
  } else {
    return (<LoadNotePopup {...props} />);
  }
}

export default LoadCardOne;